import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\AddInvoiceItemToDossierController::__invoke
* @see app/Http/Controllers/Invoice/AddInvoiceItemToDossierController.php
* @route '/api/invoicing/{invoice_item}/add-invoice-item-dossier'
*/
const AddInvoiceItemToDossierController = (args: { invoice_item: string | number | { id: string | number } } | [invoice_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddInvoiceItemToDossierController.url(args, options),
    method: 'post',
})

AddInvoiceItemToDossierController.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice_item}/add-invoice-item-dossier',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\AddInvoiceItemToDossierController::__invoke
* @see app/Http/Controllers/Invoice/AddInvoiceItemToDossierController.php
* @route '/api/invoicing/{invoice_item}/add-invoice-item-dossier'
*/
AddInvoiceItemToDossierController.url = (args: { invoice_item: string | number | { id: string | number } } | [invoice_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice_item: typeof args.invoice_item === 'object'
        ? args.invoice_item.id
        : args.invoice_item,
    }

    return AddInvoiceItemToDossierController.definition.url
            .replace('{invoice_item}', parsedArgs.invoice_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\AddInvoiceItemToDossierController::__invoke
* @see app/Http/Controllers/Invoice/AddInvoiceItemToDossierController.php
* @route '/api/invoicing/{invoice_item}/add-invoice-item-dossier'
*/
AddInvoiceItemToDossierController.post = (args: { invoice_item: string | number | { id: string | number } } | [invoice_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddInvoiceItemToDossierController.url(args, options),
    method: 'post',
})

export default AddInvoiceItemToDossierController